import getHeight from './get-height';

export default {
  getHeight,
};
